export function findSidebarWidth() {
  const minWidth = 220;
  const maxWidth = 300;
  const sidebarWidth = window.innerWidth * 0.22;

  return Math.min(Math.max(sidebarWidth, minWidth), maxWidth);
}
